import {
  Box,
  Button,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { rem } from "assets/js/common";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import ShoppingMemoList from "components/shopping-memo";
import FavoriteProduct from "components/shopping-memo/favorite-product";

const useStyles = makeStyles((theme) => ({
  shoppingMemo: {
    "& .regist-shopping": {
      minHeight: rem(208),
      padding: `${rem(30)} ${rem(25)}`,
      backgroundColor: theme.palette.background.default,
      "& .MuiFormControl-root": {
        marginBottom: rem(13),
        "& .count": {
          fontSize: rem(12),
        },
        "& .MuiButton-text": {
          fontSize: rem(14),
        },
      },
    },
    "& .shopping-list": {
      marginTop: rem(17),
      "& > li": {
        display: "flex",
        "& .MuiFormControlLabel-root": {
          flex: "1 1 auto",
          "& .MuiButtonBase-root": {
            marginRight: rem(15),
          },
          "& .MuiTypography-root": {
            fontSize: rem(14),
            fontFamily:
              "'Malgun gothic','맑은고딕', Dotum, '돋움', arial, sans-serif",
          },
        },
        "& + li": {
          marginTop: rem(21),
        },
      },
    },
    "& .btns-text": {
      marginTop: rem(30),
      textAlign: "right",
      "& .MuiButton-text": {
        position: "relative",
        minWidth: "auto",
        fontSize: rem(14),
        fontWeight: 400,
        lineHeight: rem(22),
        "& + .MuiButton-text": {
          paddingLeft: rem(10),
          marginLeft: rem(10),
          "&:before": {
            content: "''",
            position: "absolute",
            top: "50%",
            left: 0,
            transform: "translateY(-50%)",
            width: "1px",
            height: rem(8),
            backgroundColor: theme.palette.info.light,
          },
        },
      },
    },
  },
}));

export default function ShoppingMemo(props) {
  const classes = useStyles();

  const dispatch = useDispatch();
  const [shoppingMemoList, setShoppingMemoList] = useState([]);

  const [open, setOpen] = useState(false);
  const handleAlertClose = () => {
    setOpen(false);
  };

  const [memo, setMemo] = useState({
    content: "",
    count: 0,
    limit: 10,
    checkArr: [],
  });

  // const fetchData = async () => {
  //   await axios.get("/api/mb/shopping-memo").then((res) => {
  //     setShoppingMemoList(res.data.data.shoppingMemoList);
  //   });
  // };

  // const onDelete = (seq) => {
  //   axios
  //     .post("/api/mb/shopping-memo/remove", null, {
  //       params: {
  //         seq: seq,
  //       },
  //     })
  //     .then((res) => {
  //       fetchData();
  //     });
  // };

  // const onSelectDelete = (seq) => {
  //   axios
  //     .post("/api/mb/shopping-memo/remove-list", memo.checkArr)
  //     .then((res) => {
  //       fetchData();
  //     });
  // };

  // const onAllDelete = () => {
  //   axios.post("/api/mb/shopping-memo/remove-all").then((res) => {
  //     fetchData();
  //   });
  // };

  // const onRegist = () => {
  //   if (!memo.content) return;

  //   axios
  //     .post("/api/mb/shopping-memo/regist", {
  //       memo: memo.content,
  //     })
  //     .then((res) => {
  //       if (res.data.data) {
  //         setMemo({
  //           ...memo,
  //           content: "",
  //           count: 0,
  //           checkArr: [],
  //         });
  //         fetchData();
  //       }
  //     });
  // };

  // const handleChangeCheckbox = (event) => {
  //   const target = event.target;

  //   let arr = memo.checkArr;
  //   console.log("arr", arr);
  //   if (target.checked) {
  //     arr.push(Number(target.value));
  //   } else {
  //     _.remove(arr, (item) => item == target.value);
  //   }
  //   setMemo({
  //     ...memo,
  //     checkArr: arr,
  //   });
  //   console.log("memo.checkArr", memo.checkArr);
  // };

  // const handleValueCounter = (e) => {
  //   setMemo({
  //     content: e.target.value,
  //     count: e.target.value.length,
  //     limit: 10,
  //   });
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "쇼핑메모", menu: false }));
  }, [init]);

  return (
    <main id="main" className={"container nopad " + classes.shoppingMemo}>
      <ShoppingMemoList />
      <FavoriteProduct />
    </main>
  );
}
